import { TrendingUp, TrendingDown, Minus } from "lucide-react";

type ComparisonCardProps = {
    title: string;
    currentValue: number;
    lastValue: number;
    changePercent: number | null;
    unit: string;
    monthProgress?: number;
};

export const ComparisonCard = ({ title, currentValue, lastValue, changePercent, unit, monthProgress }: ComparisonCardProps) => {
    const isPositive = changePercent !== null && changePercent > 0;
    const isNegative = changePercent !== null && changePercent < 0;
    const isNeutral = changePercent === null || changePercent === 0;
    const progressPercent = monthProgress != null ? Math.round(monthProgress * 100) : null;

    return (
        <div className="rounded-lg border bg-card p-4 sm:p-5">
            <div className="flex items-center justify-between mb-3">
                <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">{title}</p>
                {progressPercent != null && (
                    <span className="text-[10px] text-muted-foreground/70 tabular-nums">
                        {progressPercent}% through month
                    </span>
                )}
            </div>
            <div className="flex items-end justify-between gap-4">
                <div>
                    <p className="text-xs text-muted-foreground mb-1">This Month</p>
                    <p className="text-lg font-semibold text-foreground">
                        {currentValue.toLocaleString(undefined, { maximumFractionDigits: 1 })} <span className="text-sm font-normal text-muted-foreground">{unit}</span>
                    </p>
                </div>
                <div>
                    <p className="text-xs text-muted-foreground mb-1">Last Month</p>
                    <p className="text-sm text-muted-foreground">
                        {lastValue.toLocaleString(undefined, { maximumFractionDigits: 1 })} {unit}
                    </p>
                </div>
                <div className="flex items-center gap-1 flex-shrink-0">
                    {isPositive && (
                        <>
                            <TrendingUp className="h-4 w-4 text-green-600 dark:text-green-400" />
                            <span className="text-sm font-medium text-green-600 dark:text-green-400">+{changePercent!.toFixed(1)}%</span>
                        </>
                    )}
                    {isNegative && (
                        <>
                            <TrendingDown className="h-4 w-4 text-red-600 dark:text-red-400" />
                            <span className="text-sm font-medium text-red-600 dark:text-red-400">{changePercent!.toFixed(1)}%</span>
                        </>
                    )}
                    {isNeutral && (
                        <>
                            <Minus className="h-4 w-4 text-muted-foreground" />
                            <span className="text-sm font-medium text-muted-foreground">—</span>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
